import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImportedInvoiceDrawerHeaderStatus = styled.div`
  display: flex;
  order: -1;
  margin-right: ${Spacing.S8};
`
